import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class DirectorFormsFiledAndIntimations extends EntityDto implements IEntityDto {
     FormsFiled_Id: string;
    FormFiledName: string;
    Director_Id: string;
    FormFiled_Ref_Id: string;
    IndexDocument: any ="";
   
   
    

    // IsActive: boolean;
    
    // TotalCount: number;
   
    constructor() {
        super();
        this.FormsFiled_Id = "00000000-0000-0000-0000-000000000000";
         this.Director_Id = "";
        this.FormFiled_Ref_Id = "";
    //    this.IsActive = true;
    //    this.TotalCount = 0;
  this.FormFiledName="";

    }
}
